import { connect } from 'react-redux'
import { runOnNextTick } from 'util/functions'
import { selectIsLeftSidebarCollapsed } from 'selectors/app'
import { doFetchReportsBootstrapData } from 'actions/app'
import { selectKnowledgeBaseTotal } from 'subapps/kb/selectors/knowledge_bases'
import { selectIsKbsLoaded } from 'subapps/kb/selectors/knowledge_bases/selectIsKbsLoaded'
import { selectPrefersShowTopNav } from 'selectors/app/selectAccountPreferences'
import { doFetchKnowledgeBases } from 'subapps/kb/actions/knowledge_bases'
import { selectIsAccountBootstrapped } from 'selectors/app/selectAccount'
import { selectCurrentInboxPlan } from 'ducks/billing/selectors/selectCurrentInboxPlan'
import { selectMaxReportingDaysForProduct } from 'ducks/billing/selectors/features'
import { selectCurrentPage } from 'selectors/location'
import { KB_PAGE } from 'ducks/reports/kb/pages'
import { doLayoutMounted } from '../../actions'
import {
  selectLayoutMounted,
  selectShowContent,
  selectShowEmptyState,
} from '../../selectors'

import ReportsLayout from './view'

const select = state => ({
  layoutMounted: selectLayoutMounted(state),
  isLeftSidebarCollapsed: selectIsLeftSidebarCollapsed(state),
  showEmptyState: selectShowEmptyState(state),
  showContent: selectShowContent(state),
  hasKnowledgeBases: selectKnowledgeBaseTotal(state) > 0,
  isKbsLoaded: selectIsKbsLoaded(state),
  showTopNav: selectPrefersShowTopNav(state),
  isAccountBootstrapped: selectIsAccountBootstrapped(state),
  currentPlan: selectCurrentInboxPlan(state),
  reportingDaysLimit: selectMaxReportingDaysForProduct(state),
  isInKbReporting: selectCurrentPage(state) === KB_PAGE,
})

const perform = dispatch => ({
  onComponentDidMount: () => {
    runOnNextTick(() => {
      dispatch(doFetchReportsBootstrapData())
      dispatch(doLayoutMounted())
    })
  },
  onComponentDidUpdate: () => {
    runOnNextTick(() => {
      dispatch(doLayoutMounted())
    })
  },
  fetchKnowledgeBases: () => dispatch(doFetchKnowledgeBases()),
})

export default connect(select, perform)(ReportsLayout)
